module.exports = __webpack_public_path__ + "static/bulb-3e28854623ed8638eb2aa8b23adaabca.png";